import request from './index'

export function getGoodsList(params) {
  return request({
    url: '/goods/list',
    method: 'get',
    params
  })
}

export function getGoodsDetail(id) {
  return request({
    url: '/goods/' + id,
    method: 'get'
  })
}

export function createGoods(data) {
  return request({
    url: '/goods',
    method: 'post',
    data
  })
}

export function updateGoods(id, data) {
  return request({
    url: '/goods/' + id,
    method: 'put',
    data
  })
}

export function deleteGoods(id) {
  return request({
    url: '/goods/' + id,
    method: 'delete'
  })
}

export function updateGoodsStatus(id, status) {
  return request({
    url: '/goods/' + id + '/status',
    method: 'put',
    data: { status }
  })
}

export function getRentPeriods(goodsId) {
  return request({
    url: '/goods/periods/' + goodsId,
    method: 'get'
  })
}

export function updateRentPeriods(goodsId, data) {
  return request({
    url: '/goods/' + goodsId + '/periods',
    method: 'put',
    data
  })
}

export function generateGoodsQrCode(id) {
  return request({
    url: '/goods/qrcode/' + id,
    method: 'get'
  })
}